var _g, _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCouronne = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.32 85.41",
    fill: "#fff",
    strokeWidth: "0px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "44.84 64.73 68.82 64.43 71.91 50.07 71.16 49.68 54.87 56.27 50.75 28.95 49.89 28.77 34.81 56.27 13.15 40.87 12.5 41.31 21.24 64.73 44.84 64.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.64 73.55 23.29 73.55 21.67 67.85 68.42 67.85 67.64 73.55"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "4.69 27.49 1.43 34.82 7.39 40.18 14.33 36.18 12.67 28.33 4.69 27.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.14 35.13 71.24 36.51 70.11 44.45 77.31 47.98 82.89 42.22 79.14 35.13"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "54.06 11.86 46.82 15.3 47.86 23.25 55.74 24.73 59.57 17.68 54.06 11.86"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCouronne);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/couronne.a0201655df6058eaaafa08d1e15416df.svg";